import React from 'react';
import { useTranslate } from '@above-the-treeline/localization';
import UserAvatar from 'treeline-react-core-components/UserAvatar';
import TitleReview from '../Reviews/TitleReview';

function Review({ review, source, communityId }) {
	const { translate } = useTranslate();
	const getAltText = () => {
		if (review.product && review.product.name) {
			return translate('review_of_x', {
				titleName: review.product.name,
			});
		}
		return translate('title_review');
	};

	return (
		<TitleReview
			review={review}
			source={source}
			communityId={communityId}
			key={review.appUserId}>
			{source === 'user' ? (
				<div
					className="title-image"
					style={{ marginBottom: '10px', marginRight: '5px' }}>
					<img
						alt={getAltText()}
						src={review.productImageUri}
						style={{ height: '90px' }}
					/>{' '}
				</div>
			) : (
				<UserAvatar
					displayName={review.user.fullName}
					avatarUri={
						review.userAvatar.uri ? review.userAvatar.uri : null
					}
					avatarSizeClass={`avatar-medium`}
					userInitials={review.userAvatar.initials}
				/>
			)}
		</TitleReview>
	);
}

export default Review;
